import { useState } from "react"
import { CommaFire } from "../CommaFire"

export declare type InputProps = {
    name: string,
    title: string,
    required?: boolean,
    errorMessage?: string,
    custom_class?:string ,
}

export const CInputPassword = ({ name, title, required, errorMessage , custom_class}: InputProps) => {
    const [visiblePassword, setVisiblePassword] = useState<boolean>(false)

    const changeVisible = () => {
        setVisiblePassword(!visiblePassword)
    }

    return (
        <div className="flex flex-col mb-[30px] transition-all">
            <div className="flex relative px-[7px] min-h-[50px] rounded-[5px] items-center border border-dayan-gray-100 mb-[3px] focus-within:border-2 focus-within:border-dayan-orange-50">
                <span className="text-[12px] text-dayan-gray-100 absolute bg-white top-[-12px] right-[15px] px-[10px]">{title}</span>
                <input name={name} className={` w-[calc(100%-35px)] h-[35px] text-sm focus:outline-none ${custom_class}`} type={visiblePassword ? 'text' : 'password'} required={required == true ? true : false} />
                <div onClick={changeVisible} className=" w-[35px] h-[35px] flex justify-center items-center">
                    {visiblePassword ?
                        <svg x="0px" y="0px" viewBox="0 0 36 36" className={`  h-5 fill-dayan-gray-100 `}>
                            <use xlinkHref="/assetes/svg/heye.svg#heye" />
                        </svg>

                        :
                        <svg x="0px" y="0px" viewBox="0 0 512 512" className={`  h-5 fill-dayan-gray-100 `}>
                            <use xlinkHref="/assetes/svg/eye.svg#eye" />
                        </svg>
                    }
                </div>
            </div>
        </div>
    );
}